import React, {Fragment} from "react";
import {connect} from "react-redux";
import {DEFAULT_PER_PAGE} from "../../config";
import {displayErrors, normalizeEnum} from "../../libs/utils";
import {DateTimeFormat} from "../shared/DateTimeFormat";
import {Button, Col, Pagination, Row, Space, Table, Tooltip} from "antd";
import UndoOutlined from "@ant-design/icons/lib/icons/UndoOutlined";
import {loadAffiliateEarnings} from "../../actions/affiliate";
import {Link} from "react-router-dom";
import {MoneyField} from "../shared/MoneyField";
import {DateFormat} from "../shared/DateFormat";
import {StatusIndicator} from "../shared/Status";

class AffiliateEarningsTable extends React.Component {
    state = {
        loading: false,
        pagination: { current: 1, pageSize: DEFAULT_PER_PAGE, total: 0, showSizeChanger: true },
        earnings: []
    };

    componentDidMount() {
        this.loadEarnings();
    }

    loadEarnings(page = null, per_page = null) {
        if(page == null) {
            page = this.state.pagination.current;
            per_page = this.state.pagination.pageSize;
        }

        this.setState({ loading: true });

        this.props.loadAffiliateEarnings(this.props.guid, page, per_page, (res) => {
            this.setState({ loading: false, earnings: res.data.data, pagination: { current: res.data.page, pageSize: res.data.per_page, total: res.data.total, showSizeChanger: true } });
        }, (err) => {
            this.setState({ loading: false });
            displayErrors(err.response.data);
        });
    }

    render() {
        const columns = [
            { title: 'Created', dataIndex: 'date_created', render: (item) => <DateTimeFormat value={item} /> },
            { title: 'Updated', dataIndex: 'date_updated', render: (item) => <DateTimeFormat value={item} /> },
            { title: 'Clears', dataIndex: 'date_clears', render: (item) => <DateFormat value={item} /> },
            { title: 'Paid', dataIndex: 'date_paid', render: (item) => <DateFormat value={item} /> },
            { title: 'Status', dataIndex: 'status', render: (item) => <StatusIndicator status={item} el='badge' /> },
            { title: 'Company', dataIndex: 'company', render: (item) => item ? <Link to={'/accounts/companies/' + item.guid}>{item.name}</Link> : '' },
            { title: 'Revenue', dataIndex: 'payout', render: (item) => <MoneyField amount={item} currency='USD' /> },
            { title: 'Tax', dataIndex: 'tax', render: (item) => <MoneyField amount={item} currency='USD' /> },
            { title: 'Invoice', dataIndex: 'invoice', render: (item) => <Link to={'/billing/invoices/' + item.id}>#{item.id}</Link>},
            { title: 'Order', dataIndex: 'order', render: (item) => <Link to={'/billing/orders/' + item.id}>#{item.id}</Link>},
            { title: 'Rate', dataIndex: 'payout_rate', render: (item) => <span>{item.payout_rate}%</span>},
            { title: 'Type', dataIndex: 'payout_type', render: (item) => normalizeEnum(item)},
        ];

        return <Fragment>
            <Row justify='space-between' style={{marginBottom: '10px'}}>
                <Col></Col>
                <Col>
                    <Space>
                        <Tooltip title='Reload table' placement='left'><Button onClick={() => this.loadEarnings()} icon={<UndoOutlined />} size='small' type='circle'></Button></Tooltip>
                        <Pagination onChange={(page, pageSize) => this.loadEarnings(page, pageSize)} size='small' {...this.state.pagination} />
                    </Space>
                </Col>
            </Row>
            <Table
                columns={columns}
                rowKey={(item) => item.guid}
                dataSource={this.state.earnings}
                pagination={false}
                footer={() => <Row justify='space-between'>
                    <Col></Col>
                    <Col><Pagination onChange={(page, pageSize) => this.loadEarnings(page, pageSize)} size='small' {...this.state.pagination} /></Col>
                </Row>}
                loading={this.state.loading} />
        </Fragment>;
    }
}

export default connect(null, { loadAffiliateEarnings })(AffiliateEarningsTable);